export default __webpack_public_path__ + "static/media/VC_Landing_Logo.58c1b476.png";